export const testValidEmail = (email)=>{
    //super inclusive 2020 model
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}